



































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator"; // 2022-12-08 sh #8122(BQR982) add Watch.
import { Utils } from "@/service/util";
import { Auth } from "@/service/auth";
import { Action, Getter } from "vuex-class";
import requestService from "@/service/requestService";
import { PromiseService } from "@/service/PromiseService";
import { getFunctionSettingConfigKey } from "@/store/modules/functionSetting";
import { IppanSeibiService } from "@/service/IppanSeibiService";
/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import SknMenuDialog from "@/components/sknMenuDialog.vue";
import { InspectDetail } from "@/model/InspectDetail";
import { InspectionDetailService } from "@/service/InspectionDetailService";
import { InspectionShakenShuruiDetailStoreService } from "@/service/InspectionShakenShuruiDetailStoreService";
import { InspectionDetailStoreService } from "@/service/InspectionDetailStoreService";
import { MESSAGE } from "@/model/Message";
import { SocketControllers } from "@/service/SocketControllers";
import moment from "moment";
import Pagination from "@/components/common/Pagination.vue";
/** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

@Component({
  components: {
    ConfirmDialog
    , SknMenuDialog
    ,Pagination
  }
})
export default class Header extends Vue {
  @Prop() showmenu: boolean;
  @Prop() searchbox: boolean;

  
  @Action("setFontSizeLevel", { namespace: "GlobalValue" })
  setFontSizeLevel: any;

  @Getter("fontSizeLevel", { namespace: "GlobalValue" })
  fontSizeLevelVal: number;

  @Action("clearTimerRefeshToken", { namespace: "Authentication" })
  clearTimerRefeshToken: any;

  @Action("clearState", { namespace: "Authentication" })
  clearStateAuth: any;

  @Action("clearState", { namespace: "ReservationDetail" })
  clearStateReservation: any;

  @Action("clearState", { namespace: "SubHeader" })
  clearStateTime: any;

  @Action("clearState", { namespace: "InspectSeibi" })
  clearStateStatusResult: any;

  @Action("clearState", { namespace: "CarSelection" })
  clearStateCarSelection: any;

  @Action("clearState", { namespace: "Inspect" })
  clearStateInspect: any;

  @Action("clearState", { namespace: "Shohiyou" })
  clearStateShohiyou: any;

  @Action("clearState", { namespace: "Coupon" })
  clearStateCoupon: any;

  @Action("clearState", { namespace: "Environment" })
  clearStateEnvironment: any;

  @Action("clearState", { namespace: "WorkOrder" })
  clearStateWorkOrder: any;

  @Action("clearState", { namespace: "ReservationSearchData" })
  clearStateReservationSearchData: any;

  @Action("clearState", { namespace: "Payment" })
  clearPayment: any;

  @Action("clearState", { namespace: "UserDataState" })
  clearUserData: any;

  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;

  /** 2021-05-25 sh #6973 feature function setting [START] */
  @Action("clearState", { namespace: "QuickMitsumoriQrInfo" })
  clearQuickMitsumoriQrInfo: any;

  @Action("clearState", { namespace: "FunctionSetting" })
  clearFunctionSetting: any;

  /** 2021-05-25 sh #6973 feature function setting [END] */

  /** 2021-07-30 sh #6989 implements quick mitsumori. [START] */
  @Getter("currentState", { namespace: "QuickMitsumoriQrInfo" })
  currentStateQuickMitsumoriQrInfo: any;
  /** 2021-07-30 sh #6989 implements quick mitsumori. [END] */

  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  @Getter("isValid", { namespace: "FunctionSetting" })
  isValidFunctionSetting: any;
  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Getter("sknSeibiShubetsuKbn", { namespace: "ReservationDetail" })
  sknSeibiShubetsuKbn: number;

  @Action("clearState", { namespace: "Buhin" })
  clearBuhin: any;

  @Action("clearState", { namespace: "NisseirenWorkBuhin" })
  clearNisseirenWorkBuhin: any;

  @Action("setInformation", { namespace: "FunctionSetting" })
  setInformation: any;

  /** 2023-01-27 sh #8180(BQR1080) add change course. [START] */
  @Getter("isCanChangeCourse", { namespace: "FunctionSetting"} )
  isCanChangeCourse: any;
  /** 2023-01-27 sh #8180(BQR1080) add change course. [END] */

  @Getter("freeOfChargeLabelMsg", { namespace: "FunctionSetting" })
  freeOfChargeLabelMsg: any;

  @Getter("nameOfScenario", { namespace: "FunctionSetting" })
  scenarioNm: string;

  @Getter("isNextageCustom", { namespace: "FunctionSetting" })
  isNextageCustom: any;

@Getter("isReceiveInfo", { namespace: "FunctionSetting" })
  isReceiveInfo: any;

  @Getter("isNewInformation", { namespace: "FunctionSetting" })
  isNewInformation: any;
  
  @Getter("counterNewInfo", { namespace: "FunctionSetting" })
  counterNewInfo: any;



  reqService: requestService;
  inspectionDetailStore: InspectionDetailStoreService =
    new InspectionDetailStoreService();
  inspectionDetailStoreService1: InspectionShakenShuruiDetailStoreService =
    new InspectionShakenShuruiDetailStoreService();
  seibiMenuCd: string = "";
  shakenShuruiNm: string = "";

  public utils: Utils = new Utils();
  ippanSeibiService: IppanSeibiService;

  $refs!: {
    errorDialog: ConfirmDialog;
    sknMenuDialog: SknMenuDialog;
    dialog: ConfirmDialog;
    pagination: Pagination;
  };
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

  isExitBasicLoad: boolean = false; // 初期化関数制御

  auth: Auth;
  inputFilter: string = "";
  date: string = "";
  time: string = "";
  filterField: any = null;
  filterFields: any = [
    { key: null, label: "" },
    { key: "srPlateNo", label: "ナンバー" },
    { key: "kkUketsukeNm", label: "顧客名" },
    { key: "shadaiNo", label: "車台番号" }
  ];
  serverDateTime: Date = new Date();
  isUserMode: boolean = false;
  fontSizeLevel = 2;

  dialogNex: boolean=false;
  dialogInfo: boolean=false;

  informationList: any[] = [];
  informationSelect: number = 0;

  // for pagination
  dataPageList: any = [];
  itemSizeSelected: number = 8;// 10

  sktControll: SocketControllers;

  /*
   * 初期化関数
   * ( createdやmountedで1回だけ実行される必要があるが
   *   特定のパラメータが足りない時は実行順序を前後させる必要がある処理 )
   */
  @Watch("uketsukeExtendsId", {immediate:false} )
  basicLoad() {
    // 必要な値が未セット、または初期化済みなら何もしない
    if (!Number(this.uketsukeExtendsId) || this.isExitBasicLoad) { return; }
    this.isExitBasicLoad = true;

    if ( this.isShowRouteName ) {
      /** uketsukeExtendsIdが必要な最低限のロード処理 */
      this.reloadShakenShurui();
      const promiseService = new PromiseService();
      promiseService.getScenarioNo(this.uketsukeExtendsId);
    }
  }

  get isLoginPage(): boolean {
    return this.$route.name === "factorylogin" || this.$route.name === "userlogin";
  }

  created() {
    this.fontSizeLevel = this.fontSizeLevelVal;
    this.auth = new Auth();
    // localStorageの認証コンテキストは別タブと共有される。ログイン画面では
    // 旧タブのトークンが残っていても、ログイン前のFunctionSetting取得を行わない。
    const reqService: requestService = new requestService();
    this.ippanSeibiService = new IppanSeibiService();
    this.sktControll = new SocketControllers();
    if (this.$route.meta == "user") {
      this.isUserMode = true;
    }
    reqService.asyncGetServerTime().then((serverTime: number) => {
      this.serverDateTime = new Date(serverTime);
      this.startTimer();
      this.setDateTime();
    });

    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    this.reqService = new requestService();
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */

    if(!this.isLoginPage && !this.isUserMode && this.showmenu && this.isReceiveInfo && this.auth.loggedIn()) {
      const promiseService = new PromiseService();
      promiseService.getNewInformation();
    }

    /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
    /** F5とか押されるとなくなってしまうので、再取得をしておく */
    // ログイン画面では残存トークンがあっても取得せず、ログイン成功後に取得する
    if (!this.isLoginPage && !this.isValidFunctionSetting && this.auth.loggedIn()) {
      const promiseService = new PromiseService();
      const promise = promiseService.getFunctionSettingPM();
      Promise.all([promise]).then(() => {});
    }
    /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

    /** F5とか押されるとなくなってしまうので、再取得をしておく2 */
    if (!this.isLoginPage && this.auth.loggedIn()) {
      this.basicLoad();
    }

    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
    if (this.isShowChangeShakenShurui) {
      const inspectionDetailService = new InspectionDetailService();
      inspectionDetailService.getInspectionDetail(this.uketsukeExtendsId);
    }
    /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
  }

  getDate() {
    return this.utils.dateToFormat(this.serverDateTime, "MM/DD");
  }

  getTime() {
    return this.utils.dateToFormat(this.serverDateTime, "HH:mm");
  }

  setDateTime() {
    this.date = this.getDate();
    this.time = this.getTime();
  }

  updateTime() {
    const min = this.serverDateTime.getMinutes();
    this.serverDateTime.setMinutes(min + 1);
    this.serverDateTime.setSeconds(0);
    this.setDateTime();
  }

  startTimer() {
    const ms = (60 - this.serverDateTime.getSeconds()) * 1000;
    setTimeout(() => {
      this.updateTime();
      setInterval(() => {
        this.updateTime();
      }, 60000);
    }, ms);
  }

  get topRouteName(): string {
    return this.$route.meta === "user" ? "reservationNumber" : "reservation";
  }

  onMenuCommand(command: string) {
    if (command === "top") {
      if (this.$route.name !== this.topRouteName) {
        this.$router.push({ name: this.topRouteName });
      }
      return;
    }

    if (command == "logout") {
      this.auth.logout(() => {
        this.clearTimerRefeshToken();
        let loginName = this.$router.currentRoute.meta + "login";
        this.$router.push({ name: loginName });
        this.clearStateAuth();
        this.clearStateReservation();
        this.inspectionDetailStore.clearState();
        this.clearStateTime();
        this.clearStateStatusResult();
        this.clearStateCarSelection();
        this.clearStateInspect();
        this.clearStateShohiyou();
        this.clearStateCoupon();
        this.clearStateEnvironment();
        this.clearStateReservationSearchData();
        this.sktControll.disconnectSocket();
        this.clearStateWorkOrder();
        this.clearPayment();
        this.clearUserData();
        /** 2021-05-25 sh #6973 feature function setting [START] */
        this.clearQuickMitsumoriQrInfo();
        this.clearFunctionSetting();
        /** 2021-05-25 sh #6973 feature function setting [END] */
        window.sessionStorage.removeItem(getFunctionSettingConfigKey());
      });
    }

    if (command == "information") {
      this.onShowDialogInfo();
    }
  }

  onShowDialogInfo() {
    this.reqService.getInformation().then((res: any) => {
      if (res && res.length > 0) {
        this.informationList = res;
      }
      this.dialogInfo = true;
    });
  }

  informationOpen(data: any) {
    if ( this.informationSelect == 0 ) {
      this.informationSelect = data.id;
    } else {
    //  this.informationSelect = 0;
    }
  }

  informationClose(data: any) {
    // if( this.informationSelect == 0 ) {
    //   this.informationSelect = data.id;
    // } else {
      this.informationSelect = 0;
    // }
  }

  // ページネーション
  onDialog() {
    this.$refs.pagination.onDataChanges();
  }

  getDisplayTime(date: string, dateSelected: string) {
    const obj = moment(date, "YYYYMMDD");
    if (date == null || date == "") {
      return { showDate: false };
    // } else if (this.utils.formatDate(date, "YYYYMMDD") == dateSelected) {
    //   return { showDate: false };
    } else {
      return {
        showDate: true,
        // date: obj.format("M/D")
        date: obj.format("YYYY/MM/DD")
      };
    }
  }

  onSearch() {
    this.$emit("onsearch", { value: this.inputFilter, key: this.filterField });
  }

  onsearchChange() {
    this.$emit("onsearchChange");
  }

  get isConnected() {
    return this.sktControll.checkSocket();
  }

  /** 2021-07-30 sh #6989 implements quick mitsumori. [START] */
  get isReservation() {
    // 工場側限定機能
    return this.$route.name == 'reservation' ? true : false;
  }

  get isShowButtonQuickMitsumori() {
    let rslt: boolean = false;

    // 工場側限定機能
    if (this.$route.name == 'recmaintenance'
    && this.currentStateQuickMitsumoriQrInfo
    && this.currentStateQuickMitsumoriQrInfo.isHasQuickMitsumori == 1) {
      rslt = true;
    }

    return rslt;
  }

  onShowQuickMitsumori() {
    console.log("Header.onShowQuickMitsumori", this.isShowButtonQuickMitsumori);
    let url = this.currentStateQuickMitsumoriQrInfo.qrUrl;
    let title = "ｸｲｯｸ見積もり";
    let w = 1024;
    let h = 1024;

    let dualScreenLeft = window.screenLeft; // !== undefined ? window.screenLeft : screen.left;
    let dualScreenTop = window.screenTop; // !== undefined ? window.screenTop : screen.top;

    let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? 
      document.documentElement.clientWidth : screen.width;
    let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? 
      document.documentElement.clientHeight : screen.height;

    let left = ((width / 2) - (w / 2)) + dualScreenLeft;
    let top = ((height / 2) - (h / 2)) + dualScreenTop;
    let newWindow: any = window.open(url, title, 'menubar=no, status=no, toolbar=no, scrollbars=1, '
      + 'width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if (window.focus) {
      newWindow.focus();
    }
  }
  /** 2021-07-30 sh #6989 implements quick mitsumori. [END] */

  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [START] */
  get isShowChangeShakenShurui() {

    /** 2023-01-27 sh #8180(BQR1080) add change course. [START] */
    if (!this.isCanChangeCourse) {
      return false;
    }
    /** 2023-01-27 sh #8180(BQR1080) add change course. [END] */

    if (!this.selectingSeibiMenuCd || this.selectingSeibiMenuCd == '') {
      return false;
    }

    // 一般整備時は緑のみ表示
    if(this.isUserMode && this.ippanSeibiService.isIppanSeibi ) {
      return false;
    }
    
    return this.isShowRouteName;
  }

  get isShowRouteName(): boolean {
    if (this.isUserMode) {
      // ユーザー：表示マッチ
      if (
        this.$route.name == "usercustomer"
        || this.$route.name == "statusresult"
        || this.$route.name == "workdetail"
        || this.$route.name == "inspectioncost"
        || this.$route.name == "userlegal56"
        || this.$route.name == "userlegal56Nex1" 
        || this.$route.name == "requiredetail"
        || this.$route.name == "userlegal56Nex2" 
        || this.$route.name == "soukouhosho"
        || this.$route.name == "userrecommend"
        || this.$route.name == "discountcoupon"
        || this.$route.name == "option"
        || this.$route.name == "paymentdetail"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      // 工場：非表示マッチ
      if (this.$route.name == 'customer'
      || this.$route.name == 'inspectiondetail'
      || this.$route.name == 'factorylogin'
      || this.$route.name == 'userlogin'
      || this.$route.name == 'reservation'
      ) {
        return false;
      } else {
        return true;
      }
    }
  }

  showSknMenuDialog() {
    this.$refs.sknMenuDialog.onOpen();
  }

  onConfirm(seibiMenuCd: string,seibiMenuNm: string) {
    this.seibiMenuCd = seibiMenuCd;
    this.shakenShuruiNm = seibiMenuNm;
    if ( this.isNextageCustom ) {
      // 専用ダイアログ呼び出し
      this.dialogNex = true;
    } else {
      this.$refs.dialog.onOpen();
    }
  }

  updateShakenShurui(mode: number) {
    let sendMode = mode>0? mode : 0;
    let inspectionDetail: InspectDetail = {
      kensain: [],
      seibishi: [],
      hojoSeibishi: []
      , uketsukeExtendId: this.uketsukeExtendsId
      , shakenShuruiSeibiMenuCd: this.seibiMenuCd
      ,shakenShuruiNm: this.shakenShuruiNm
      , screen: this.$route.meta
      , shakenShuruiSeibiMenuUpdatedAt: this.shakenShuruiSeibiMenuUpdatedAt
      , sknSeibiShubetsuKbn: this.sknSeibiShubetsuKbn
    };
    this.$refs.sknMenuDialog.setLoading(true);
    // sendSocket:08車検コース変更による再描画指示
    this.reqService.updateShakenShurui(inspectionDetail,sendMode).then(
      (res: any) => {
        this.clearBuhin();
        this.clearNisseirenWorkBuhin();
        this.inspectionDetailStoreService1.setSeibiMenuCd(this.seibiMenuCd);
        this.inspectionDetailStoreService1.setShakenShuruiNm(this.shakenShuruiNm);
        if (res.body) {
          // this.setShakenShuruiNm(res.body.shakenShuruiNm);
          this.inspectionDetailStoreService1.setShakenShuruiSeibiMenuUpdatedAt(
            res.body.shakenShuruiSeibiMenuUpdatedAt
          );
        } else {
          if (res.status && res.status == 204) {
            this.$notify.error({
              title: "Error",
              message: MESSAGE.UpdatedShakenIntegrityError
            });
          }
        }
        this.$refs.sknMenuDialog.selShakenShurui(this.seibiMenuCd);
        // this.shakenShuruiNm
        this.$refs.sknMenuDialog.setLoading(false);
        this.$refs.sknMenuDialog.onClose();
      }
    );
  }

  // get selectingShakenShuruiNm() {
  //  return this.shakenShuruiNm;
  // }

  reloadShakenShurui() {
    this.reqService.getInsectionDetail(this.uketsukeExtendsId).then((data: any) => {
      this.inspectionDetailStoreService1.setSeibiMenuCd(data.shakenShuruiSeibiMenuCd);
      this.inspectionDetailStoreService1.setShakenShuruiNm(data.shakenShuruiNm);
      this.inspectionDetailStoreService1.setShakenShuruiSeibiMenuUpdatedAt(data.shakenShuruiSeibiMenuUpdatedAt);
    });
  }

  get selectingSeibiMenuCd(): string {
    return this.inspectionDetailStoreService1.seibiMenuCd;
  }

  get selectingShakenShuruiNm(): any {
    return this.inspectionDetailStoreService1.shakenShuruiNm;
  }

  get shakenShuruiSeibiMenuUpdatedAt(): any {
    return this.inspectionDetailStoreService1.shakenShuruiSeibiMenuUpdatedAt;
  }

  @Watch("selectingSeibiMenuCd")
  reInitShakenShurui() {
    const inspectionDetailService = new InspectionDetailService();
    inspectionDetailService.getInspectionDetail(this.uketsukeExtendsId);
  }
  /** 2022-12-08 sh #8122(BQR982) reload after change shaken-shurui. [END] */
}
